<template>
  <div class="red_packet_list">
    <div class="feature_row">
      <el-button type="primary" @click="createRedPack">新建红包</el-button>
    </div>
    <div class="table_row" v-loading="loading">
      <el-table :data="tableData" style="width: 100%" class="table_row" ref="table">
        <el-table-column prop="redpack_name" label="红包名称" fixed width="160"></el-table-column>
        <el-table-column label="红包类型">
          <template slot-scope="scope">
            {{ scope.row.redpack_type == 1 ? '随机红包' : '固定红包' }}
          </template>
        </el-table-column>
        <el-table-column prop="total_amount" label="红包总额(元)" width="120">
          <template slot-scope="scope">{{ scope.row.total_amount / 100 }}</template>
        </el-table-column>
        <el-table-column prop="total_num" label="红包数量"></el-table-column>
        <el-table-column prop="revd_amount" label="已领金额（元）" width="120">
          <template slot-scope="scope">{{ scope.row.revd_amount / 100 }}</template>
        </el-table-column>
        <el-table-column prop="revd_num" label="已领数量"></el-table-column>
        <el-table-column prop="unrevd_amount" label="未领金额（元）" width="120">
          <template slot-scope="scope">{{ scope.row.unrevd_amount / 100 }}</template>
        </el-table-column>
        <el-table-column prop="unrevd_num" label="未领个数"></el-table-column>
        <el-table-column label="发送状态">
          <template slot-scope="scope">
            {{ statusData[scope.row.send_status] }}
          </template>
        </el-table-column>
        <el-table-column label="发送时间" width="150">
          <template slot-scope="scope">
            <!-- {{ scope.row.send_time | parseTime }} -->
            {{ scope.row.send_time }}
          </template>
        </el-table-column>
        <el-table-column prop="create_user" label="创建人"></el-table-column>
        <el-table-column label="创建时间" width="150">
          <template slot-scope="scope">
            <!-- {{ scope.row.create_time | parseTime }} -->
            {{ scope.row.create_time }}
          </template>
        </el-table-column>
        <el-table-column prop="update_user" label="更新人"></el-table-column>
        <el-table-column label="更新时间" width="150">
          <template slot-scope="scope">
            <!-- {{ scope.row.update_time | parseTime }} -->
            {{ scope.row.update_time }}
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="130">
          <template slot-scope="scope">
            <div v-if="scope.row.send_status == 1">
              <el-button type="text" @click="viewCol(scope.row)">查看</el-button>
            </div>
            <div v-else>
              <el-button type="text" @click="sendPacket(scope.row)">发送</el-button>
              <el-button type="text" @click="editCol(scope.row)">编辑</el-button>
              <el-button type="text" @click="delCol(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination_col">
      <el-pagination
        style="background-color: #ffffff"
        layout="total, sizes,prev, pager, next, jumper"
        :total="total"
        :page-size="form.page_size"
        :current-page="form.page_index"
        :page-sizes="g_pageSizesConfig"
        @current-change="currentChange"
        @size-change="sizeChange"
      />
    </div>
    <send-redpack
      v-if="showSendRedpack"
      :id="sendId"
      :title="sendTitle"
      @sendSuccess="sendRedpackSuccess"
      @close="showSendRedpack = false"
    />
  </div>
</template>
<script>
import sendRedpack from '../components/sendRedpack/index';
import { getRedpackListApi, deleteRedpackInfoApi } from '@/api/enterpriseWeChatManagement';
import { mapGetters } from 'vuex';
import { awaitInterfaceResponse } from '@/utils/util';
export default {
  components: {
    sendRedpack,
  },
  data() {
    return {
      tableData: [],
      total: 0,
      form: {
        page_size: 10,
        page_index: 1,
      },
      statusData: {
        0: '未发送',
        1: '已发送',
        2: '发送失败',
      },
      showSendRedpack: false,
      loading: false,
      sendId: null,
    };
  },
  computed: {
    ...mapGetters('user', {
      userid: 'getUserId',
    }),
  },
  created() {
    this.form.page_size = this.g_pageSizeDefault;
    this.loading = true;
    awaitInterfaceResponse('userid', this)
      .then(() => {
        this.getRedpackList();
      })
      .catch(() => {
        this.loading = false;
        this.$message.error('无法找到userId');
      });
  },
  methods: {
    // 页行数变化回调
    sizeChange(val) {
      this.form.page_size = val;
      this.form.page_index = 1;
      this.getRedpackList();
    },
    // 页码变化回调
    currentChange(val) {
      this.form.page_index = val;
      this.getRedpackList();
    },
    // 查看
    viewCol(row) {
      this.$emit('changeComponet', 'redPacketView', { id: row.id });
    },
    // 发送红包
    sendPacket(row) {
      this.sendId = row.id;
      this.sendTitle = row.redpack_name;
      this.showSendRedpack = true;
    },
    // 编辑
    editCol(row) {
      this.$emit('changeComponet', 'redPacketAdd', { id: row.id });
    },
    // 删除
    delCol(row) {
      this.$confirm('确定删除红包数据吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'orange_confirm',
        closeOnClickModal: false,
      }).then(() => {
        this.deleteRedpackInfo(row.id);
      });
    },
    // 新建红包
    createRedPack() {
      this.$emit('changeComponet', 'redPacketAdd');
    },
    // 获取红包列表
    getRedpackList(noReset) {
      const form = Object.assign(this.form, { user_id: String(this.userid) });
      this.loading = true;
      getRedpackListApi(form)
        .then((res) => {
          if (!noReset) {
            this.tableData = [];
          }
          this.loading = false;
          this.$nextTick(() => {
            this.tableData = res.info;
          });
          this.total = res.total;
        })
        .catch((e) => {
          this.$message.error(e.message);
        });
    },
    // 删除红包
    deleteRedpackInfo(id) {
      this.loading = true;
      deleteRedpackInfoApi({
        id,
      })
        .then(() => {
          this.$message.success('删除成功!');
          this.getRedpackList(true);
        })
        .catch((e) => {
          this.loading = false;
          this.$message.error(e.message);
        });
    },
    // 成功发送红包后回调
    sendRedpackSuccess() {
      this.showSendRedpack = false;
      this.getRedpackList();
    },
  },
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
